export enum WALLET_PROVIDERS {
  GLOBAL = 'DW',
  LOCAL = 'IW',
}
